import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Navbar from './components/layout/Navbar'
import Dashboard from './components/dashboard/Dashboard'
import ProjectDetails from './components/projects/ProjectDetails'
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'
import CreateProjecct from './components/projects/CreateProject'
import CreateStudy from './components/projects/CreateStudy'
import CreateTest from './components/projects/CreateTest'
import Minigame from './components/projects/Minigame'
import CreateStudy1 from './components/projects/CreateStudy1'
import CreateStudy2 from './components/projects/CreateStudy2'
import CreateStudy3 from './components/projects/CreateStudy3'
import CreateStudy4 from './components/projects/CreateStudy4'
import CreateStudy5 from './components/projects/CreateStudy5'
import CreateStudy6 from './components/projects/CreateStudy6'
import CreateStudy7 from './components/projects/CreateStudy7'
import "./App.css"
import 'bootstrap/dist/css/bootstrap.css';
import conclude1_0 from './components/projectrandom/conclude/conclude1_0'
import conclude2_1 from './components/projectrandom/conclude/conclude2_1'
import conclude3_1 from './components/projectrandom/conclude/conclude3_1'
import conclude4_2 from './components/projectrandom/conclude/conclude4_2'
import conclude5_1 from './components/projectrandom/conclude/conclude5_1'
import conclude6_2 from './components/projectrandom/conclude/conclude6_2'
import conclude7_2 from './components/projectrandom/conclude/conclude7_2'
import conclude8_3 from './components/projectrandom/conclude/conclude8_3'
import conclude9_1 from './components/projectrandom/conclude/conclude9_1'
import conclude10_2 from './components/projectrandom/conclude/conclude10_2'
import conclude11_2 from './components/projectrandom/conclude/conclude11_2'
import conclude12_3 from './components/projectrandom/conclude/conclude12_3'
import conclude13_2 from './components/projectrandom/conclude/conclude13_2'
import conclude14_3 from './components/projectrandom/conclude/conclude14_3'
import conclude15_3 from './components/projectrandom/conclude/conclude15_3'
import conclude16_4 from './components/projectrandom/conclude/conclude16_4'
import conclude17_1 from './components/projectrandom/conclude/conclude17_1'
import conclude18_2 from './components/projectrandom/conclude/conclude18_2'
import conclude19_2 from './components/projectrandom/conclude/conclude19_2'
import conclude20_3 from './components/projectrandom/conclude/conclude20_3'
import conclude21_2 from './components/projectrandom/conclude/conclude21_2'
import conclude22_3 from './components/projectrandom/conclude/conclude22_3'
import conclude23_3 from './components/projectrandom/conclude/conclude23_3'
import conclude24_4 from './components/projectrandom/conclude/conclude24_4'
import conclude25_2 from './components/projectrandom/conclude/conclude25_2'
import conclude26_3 from './components/projectrandom/conclude/conclude26_3'
import conclude27_3 from './components/projectrandom/conclude/conclude27_3'
import conclude28_4 from './components/projectrandom/conclude/conclude28_4'
import conclude29_3 from './components/projectrandom/conclude/conclude29_3'
import conclude30_4 from './components/projectrandom/conclude/conclude30_4'
import conclude31_4 from './components/projectrandom/conclude/conclude31_4'
import conclude32_5 from './components/projectrandom/conclude/conclude32_5'
import Randomtest from './components/projectrandom/Randomtest'
import Randomtest1 from './components/projectrandom/Randomtest1'
import Randomtest2 from './components/projectrandom/Randomtest2'
import Randomtest3 from './components/projectrandom/Randomtest3'
import Randomtest4 from './components/projectrandom/Randomtest4'
import Randomtest5 from './components/projectrandom/Randomtest5'
import Randomtest6 from './components/projectrandom/Randomtest6'
import Randomtest7 from './components/projectrandom/Randomtest7'
import Randomtest8 from './components/projectrandom/Randomtest8'
import Randomtest9 from './components/projectrandom/Randomtest9'
import Randomtest10 from './components/projectrandom/Randomtest10'
import Randomtest11 from './components/projectrandom/Randomtest11'
import Randomtest12 from './components/projectrandom/Randomtest12'
import Randomtest13 from './components/projectrandom/Randomtest13'
import Randomtest14 from './components/projectrandom/Randomtest14'
import Randomtest15 from './components/projectrandom/Randomtest15'
import Randomtest16 from './components/projectrandom/Randomtest16'
import Randomtest17 from './components/projectrandom/Randomtest17'
import Randomtest18 from './components/projectrandom/Randomtest18'
import Randomtest19 from './components/projectrandom/Randomtest19'
import Randomtest20 from './components/projectrandom/Randomtest20'
import Randomtest21 from './components/projectrandom/Randomtest21'
import Randomtest22 from './components/projectrandom/Randomtest22'
import Randomtest23 from './components/projectrandom/Randomtest23'
import Randomtest24 from './components/projectrandom/Randomtest24'
import Randomtest25 from './components/projectrandom/Randomtest25'
import Randomtest26 from './components/projectrandom/Randomtest26'
import Randomtest27 from './components/projectrandom/Randomtest27'
import Randomtest28 from './components/projectrandom/Randomtest28'
import Randomtest29 from './components/projectrandom/Randomtest29'
import Randomtest30 from './components/projectrandom/Randomtest30'
import Randomtest31 from './components/projectrandom/Randomtest31'

import Randomtest1_2 from './components/projectrandom/Randomtest1_2'
import Randomtest1_3 from './components/projectrandom/Randomtest1_3'
import Randomtest2_2 from './components/projectrandom/Randomtest2_2'
import Randomtest3_2 from './components/projectrandom/Randomtest3_2'
import Randomtest4_2 from './components/projectrandom/Randomtest4_2'
import Randomtest5_2 from './components/projectrandom/Randomtest5_2'
import Randomtest6_2 from './components/projectrandom/Randomtest6_2'
import Randomtest7_2 from './components/projectrandom/Randomtest7_2'
import Randomtest8_2 from './components/projectrandom/Randomtest8_2'
import Randomtest9_2 from './components/projectrandom/Randomtest9_2'
import Randomtest10_2 from './components/projectrandom/Randomtest10_2'
import Randomtest11_2 from './components/projectrandom/Randomtest11_2'
import Randomtest12_2 from './components/projectrandom/Randomtest12_2'
import Randomtest13_2 from './components/projectrandom/Randomtest13_2'
import Randomtest14_2 from './components/projectrandom/Randomtest14_2'
import Randomtest15_2 from './components/projectrandom/Randomtest15_2'
import Randomtest16_2 from './components/projectrandom/Randomtest16_2'
import Randomtest17_2 from './components/projectrandom/Randomtest17_2'
import Randomtest18_2 from './components/projectrandom/Randomtest18_2'
import Randomtest19_2 from './components/projectrandom/Randomtest19_2'
import Randomtest20_2 from './components/projectrandom/Randomtest20_2'
import Randomtest21_2 from './components/projectrandom/Randomtest21_2'
import Randomtest22_2 from './components/projectrandom/Randomtest22_2'
import Randomtest23_2 from './components/projectrandom/Randomtest23_2'
import Randomtest24_2 from './components/projectrandom/Randomtest24_2'
import Randomtest25_2 from './components/projectrandom/Randomtest25_2'
import Randomtest26_2 from './components/projectrandom/Randomtest26_2'
import Randomtest27_2 from './components/projectrandom/Randomtest27_2'
import Randomtest28_2 from './components/projectrandom/Randomtest28_2'
import Randomtest29_2 from './components/projectrandom/Randomtest29_2'
import Randomtest30_2 from './components/projectrandom/Randomtest30_2'
import Randomtest31_2 from './components/projectrandom/Randomtest31_2'
import review1_0 from './components/projectrandom/review/review1_0'
import review2_1 from './components/projectrandom/review/review2_1'
import review3_1 from './components/projectrandom/review/review3_1'
import review4_2 from './components/projectrandom/review/review4_2'
import review5_1 from './components/projectrandom/review/review5_1'
import review6_2 from './components/projectrandom/review/review6_2'
import review7_2 from './components/projectrandom/review/review7_2'
import review8_3 from './components/projectrandom/review/review8_3'
import review9_1 from './components/projectrandom/review/review9_1'
import review10_2 from './components/projectrandom/review/review10_2'
import review11_2 from './components/projectrandom/review/review11_2'
import review12_3 from './components/projectrandom/review/review12_3'
import review13_2 from './components/projectrandom/review/review13_2'
import review14_3 from './components/projectrandom/review/review14_3'
import review15_3 from './components/projectrandom/review/review15_3'
import review16_4 from './components/projectrandom/review/review16_4'
import review17_1 from './components/projectrandom/review/review17_1'
import review18_2 from './components/projectrandom/review/review18_2'
import review19_2 from './components/projectrandom/review/review19_2'
import review20_3 from './components/projectrandom/review/review20_3'
import review21_2 from './components/projectrandom/review/review21_2'
import review22_3 from './components/projectrandom/review/review22_3'
import review23_3 from './components/projectrandom/review/review23_3'
import review24_4 from './components/projectrandom/review/review24_4'
import review25_2 from './components/projectrandom/review/review25_2'
import review26_3 from './components/projectrandom/review/review26_3'
import review27_3 from './components/projectrandom/review/review27_3'
import review28_4 from './components/projectrandom/review/review28_4'
import review29_3 from './components/projectrandom/review/review29_3'
import review30_4 from './components/projectrandom/review/review30_4'
import review31_4 from './components/projectrandom/review/review31_4'
import review32_5 from './components/projectrandom/review/review32_5'


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <switch>
            <Route exact path='/' component={Dashboard} />
            <Route path='/project/:id' component={ProjectDetails} />
            <Route path='/signin' component={SignIn} />
            <Route path='/signUp' component={SignUp} />
            <Route path='/create' component={CreateProjecct} />
            <Route path='/study' component={CreateStudy} /> 
            <Route path='/test' component={CreateTest} />
            <Route path='/minigame' component={Minigame} />
            <Route path='/createStudy1' component={CreateStudy1} />
            <Route path='/createStudy2' component={CreateStudy2} />
            <Route path='/createStudy3' component={CreateStudy3} />
            <Route path='/createStudy4' component={CreateStudy4} />
            <Route path='/createStudy5' component={CreateStudy5} />
            <Route path='/createStudy6' component={CreateStudy6} />
            <Route path='/createStudy7' component={CreateStudy7} />
            <Route path='/randomtest' component={Randomtest} />
            <Route path='/randomtest1' component={Randomtest1} />
            <Route path='/randomtest2' component={Randomtest2} />
            <Route path='/randomtest3' component={Randomtest3} />
            <Route path='/randomtest4' component={Randomtest4} />
            <Route path='/randomtest5' component={Randomtest5} />
            <Route path='/randomtest6' component={Randomtest6} />
            <Route path='/randomtest7' component={Randomtest7} />
            <Route path='/randomtest8' component={Randomtest8} />
            <Route path='/randomtest9' component={Randomtest9} />
            <Route path='/randomtest10' component={Randomtest10} />
            <Route path='/randomtest11' component={Randomtest11} />
            <Route path='/randomtest12' component={Randomtest12} />
            <Route path='/randomtest13' component={Randomtest13} />
            <Route path='/randomtest14' component={Randomtest14} />
            <Route path='/randomtest15' component={Randomtest15} />
            <Route path='/randomtest16' component={Randomtest16} />
            <Route path='/randomtest17' component={Randomtest17} />
            <Route path='/randomtest18' component={Randomtest18} />
            <Route path='/randomtest19' component={Randomtest19} />
            <Route path='/randomtest20' component={Randomtest20} />
            <Route path='/randomtest21' component={Randomtest21} />
            <Route path='/randomtest22' component={Randomtest22} />
            <Route path='/randomtest23' component={Randomtest23} />
            <Route path='/randomtest24' component={Randomtest24} />
            <Route path='/randomtest25' component={Randomtest25} />
            <Route path='/randomtest26' component={Randomtest26} />
            <Route path='/randomtest27' component={Randomtest27} />
            <Route path='/randomtest28' component={Randomtest28} />
            <Route path='/randomtest29' component={Randomtest29} />
            <Route path='/randomtest30' component={Randomtest30} />
            <Route path='/randomtest31' component={Randomtest31} />
            
            <Route path='/randomtest1_2' component={Randomtest1_2} />
            <Route path='/randomtest1_3' component={Randomtest1_3} />
            <Route path='/randomtest2_2' component={Randomtest2_2} />
            <Route path='/randomtest3_2' component={Randomtest3_2} />
            <Route path='/randomtest4_2' component={Randomtest4_2} />
            <Route path='/randomtest5_2' component={Randomtest5_2} />
            <Route path='/randomtest6_2' component={Randomtest6_2} />
            <Route path='/randomtest7_2' component={Randomtest7_2} />
            <Route path='/randomtest8_2' component={Randomtest8_2} />
            <Route path='/randomtest9_2' component={Randomtest9_2} />
            <Route path='/randomtest10_2' component={Randomtest10_2} />
            <Route path='/randomtest11_2' component={Randomtest11_2} />
            <Route path='/randomtest12_2' component={Randomtest12_2} />
            <Route path='/randomtest13_2' component={Randomtest13_2} />
            <Route path='/randomtest14_2' component={Randomtest14_2} />
            <Route path='/randomtest15_2' component={Randomtest15_2} />
            <Route path='/randomtest16_2' component={Randomtest16_2} />
            <Route path='/randomtest17_2' component={Randomtest17_2} />
            <Route path='/randomtest18_2' component={Randomtest18_2} />
            <Route path='/randomtest19_2' component={Randomtest19_2} />
            <Route path='/randomtest20_2' component={Randomtest20_2} />
            <Route path='/randomtest21_2' component={Randomtest21_2} />
            <Route path='/randomtest22_2' component={Randomtest22_2} />
            <Route path='/randomtest23_2' component={Randomtest23_2} />
            <Route path='/randomtest24_2' component={Randomtest24_2} />
            <Route path='/randomtest25_2' component={Randomtest25_2} />
            <Route path='/randomtest26_2' component={Randomtest26_2} />
            <Route path='/randomtest27_2' component={Randomtest27_2} />
            <Route path='/randomtest28_2' component={Randomtest28_2} />
            <Route path='/randomtest29_2' component={Randomtest29_2} />
            <Route path='/randomtest30_2' component={Randomtest30_2} />
            <Route path='/randomtest31_2' component={Randomtest31_2} />
            <Route path='/conclude1_0' component={conclude1_0} />
            <Route path='/conclude2_1' component={conclude2_1} />
            <Route path='/conclude3_1' component={conclude3_1} />
            <Route path='/conclude4_2' component={conclude4_2} />
            <Route path='/conclude5_1' component={conclude5_1} />
            <Route path='/conclude6_2' component={conclude6_2} />
            <Route path='/conclude7_2' component={conclude7_2} />
            <Route path='/conclude8_3' component={conclude8_3} />
            <Route path='/conclude9_1' component={conclude9_1} />
            <Route path='/conclude10_2' component={conclude10_2} />
            <Route path='/conclude11_2' component={conclude11_2} />
            <Route path='/conclude12_3' component={conclude12_3} />
            <Route path='/conclude13_2' component={conclude13_2} />
            <Route path='/conclude14_3' component={conclude14_3} />
            <Route path='/conclude15_3' component={conclude15_3} />
            <Route path='/conclude16_4' component={conclude16_4} />
            <Route path='/conclude17_1' component={conclude17_1} />
            <Route path='/conclude18_2' component={conclude18_2} />
            <Route path='/conclude19_2' component={conclude19_2} />
            <Route path='/conclude20_3' component={conclude20_3} />
            <Route path='/conclude21_2' component={conclude21_2} />
            <Route path='/conclude22_3' component={conclude22_3} />
            <Route path='/conclude23_3' component={conclude23_3} />
            <Route path='/conclude24_4' component={conclude24_4} />
            <Route path='/conclude25_2' component={conclude25_2} />
            <Route path='/conclude26_3' component={conclude26_3} />
            <Route path='/conclude27_3' component={conclude27_3} />
            <Route path='/conclude28_4' component={conclude28_4} />
            <Route path='/conclude29_3' component={conclude29_3} />
            <Route path='/conclude30_4' component={conclude30_4} />
            <Route path='/conclude31_4' component={conclude31_4} />
            <Route path='/conclude32_5' component={conclude32_5} />
            <Route path='/review1_0' component={review1_0} />
            <Route path='/review2_1' component={review2_1} />
            <Route path='/review3_1' component={review3_1} />
            <Route path='/review4_2' component={review4_2} />
            <Route path='/review5_1' component={review5_1} />
            <Route path='/review6_2' component={review6_2} />
            <Route path='/review7_2' component={review7_2} />
            <Route path='/review8_3' component={review8_3} />
            <Route path='/review9_1' component={review9_1} />
            <Route path='/review10_2' component={review10_2} />
            <Route path='/review11_2' component={review11_2} />
            <Route path='/review12_3' component={review12_3} />
            <Route path='/review13_2' component={review13_2} />
            <Route path='/review14_3' component={review14_3} />
            <Route path='/review15_3' component={review15_3} />
            <Route path='/review16_4' component={review16_4} />
            <Route path='/review17_1' component={review17_1} />
            <Route path='/review18_2' component={review18_2} />
            <Route path='/review19_2' component={review19_2} />
            <Route path='/review20_3' component={review20_3} />
            <Route path='/review21_2' component={review21_2} />
            <Route path='/review22_3' component={review22_3} />
            <Route path='/review23_3' component={review23_3} />
            <Route path='/review24_4' component={review24_4} />
            <Route path='/review25_2' component={review25_2} />
            <Route path='/review26_3' component={review26_3} />
            <Route path='/review27_3' component={review27_3} />
            <Route path='/review28_4' component={review28_4} />
            <Route path='/review29_3' component={review29_3} />
            <Route path='/review30_4' component={review30_4} />
            <Route path='/review31_4' component={review31_4} />
            <Route path='/review32_5' component={review32_5} />
         

          </switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
